import Collapse from 'bootstrap/js/dist/collapse';
import Dropdown from 'bootstrap/js/dist/dropdown';
import '/sass/main.scss';
(function() {
    "use strict";
 
    
// Spinner
function spinner() {
    setTimeout(function () {
        var spinner = document.getElementById('spinner');
        if (spinner) {
            spinner.classList.remove('show');
        }
    }, 1);
}
spinner();

// Color Modes
const getStoredTheme = () => localStorage.getItem('theme')
const setStoredTheme = theme => localStorage.setItem('theme', theme)

const getPreferredTheme = () => {
    const storedTheme = getStoredTheme()
    if (storedTheme) {
        return storedTheme
    }

    // return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
    return 'light' // Default to light theme instead of checking system preference
}

const setTheme = theme => {
    if (theme === 'auto') {
        document.documentElement.setAttribute('data-bs-theme', (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'))
    } else {
        document.documentElement.setAttribute('data-bs-theme', theme)
    }
}

setTheme(getPreferredTheme())

const showActiveTheme = (theme, focus = false) => {
    const themeSwitcher = document.querySelector('#bd-theme')

    if (!themeSwitcher) {
        return
    }

    const themeSwitcherText = document.querySelector('#bd-theme-text')
    const activeThemeIcon = document.querySelector('.theme-icon-active use')
    const btnToActive = document.querySelector(`[data-bs-theme-value="${theme}"]`)
    const svgOfActiveBtn = btnToActive.querySelector('svg use').getAttribute('href')

    document.querySelectorAll('[data-bs-theme-value]').forEach(element => {
        element.classList.remove('active')
        element.setAttribute('aria-pressed', 'false')
    })

    btnToActive.classList.add('active')
    btnToActive.setAttribute('aria-pressed', 'true')
    activeThemeIcon.setAttribute('href', svgOfActiveBtn)
    const themeSwitcherLabel = `${themeSwitcherText.textContent} (${btnToActive.dataset.bsThemeValue})`
    themeSwitcher.setAttribute('aria-label', themeSwitcherLabel)

    if (focus) {
        themeSwitcher.focus()
    }
}

window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
    const storedTheme = getStoredTheme()
    if (storedTheme === 'auto') {
        setTheme(getPreferredTheme())
    }
})

window.addEventListener('DOMContentLoaded', () => {
    showActiveTheme(getPreferredTheme())

    document.querySelectorAll('[data-bs-theme-value]')
        .forEach(toggle => {
            toggle.addEventListener('click', () => {
                const theme = toggle.getAttribute('data-bs-theme-value')
                setStoredTheme(theme)
                setTheme(theme)
                showActiveTheme(theme, true)
            })
        })
})
// Sticky Navbar
window.addEventListener('scroll', function () {
    var navbar = document.querySelector('.sticky-top');
    if (window.scrollY > 50) {
        navbar.classList.add('shadow-sm');
    } else {
        navbar.classList.remove('shadow-sm');
    }
});


// Back to top button
window.addEventListener('scroll', function () {
    var backToTop = document.querySelector('.back-to-top');
    if (window.scrollY > 300) {
        backToTop.style.display = 'block';
    } else {
        backToTop.style.display = 'none';
    }
});
document.querySelector('.back-to-top').addEventListener('click', function () {
    window.scrollTo({top: 0, behavior: 'smooth'});
});
const currentPath = window.location.pathname;
if (currentPath.includes('experience.html')) {
      import('bootstrap/js/dist/modal').then(module => {
  });
}
else if (currentPath.includes('portfolio.html')) {
    
    // Modern, lightweight imagesLoaded replacement
    function waitForImages(container) {
        return new Promise((resolve) => {
            const images = container.querySelectorAll('img');
            
            if (images.length === 0) {
                resolve();
                return;
            }
            
            let loadedCount = 0;
            const totalImages = images.length;
            
            function imageLoaded() {
                loadedCount++;
                if (loadedCount === totalImages) {
                    resolve();
                }
            }
            
            images.forEach(img => {
                if (img.complete && img.naturalWidth !== 0) {
                    imageLoaded();
                } else {
                    img.addEventListener('load', imageLoaded);
                    img.addEventListener('error', imageLoaded); // Count errors as "loaded" to prevent hanging
                }
            });
        });
    }
    
    async function initPortfolio() {
        // Dynamic import of Isotope
        const { default: Isotope } = await import('isotope-layout');
        
        document.querySelectorAll('.isotope-layout').forEach(async function(isotopeItem) {
            const layout = isotopeItem.getAttribute('data-layout') ?? 'masonry';
            const filter = isotopeItem.getAttribute('data-default-filter') ?? '*';
            const sort = isotopeItem.getAttribute('data-sort') ?? 'original-order';
            
            const container = isotopeItem.querySelector('.isotope-container');
            
            // Wait for images to load, then initialize Isotope
            await waitForImages(container);
            
            const isotope = new Isotope(container, {
                itemSelector: '.isotope-item',
                layoutMode: layout,
                filter: filter,
                sortBy: sort
            });

            // Set up filter buttons
            isotopeItem.querySelectorAll('.isotope-filters li').forEach(function(filterBtn) {
                filterBtn.addEventListener('click', function() {
                    // Remove active class from current active filter
                    isotopeItem.querySelector('.isotope-filters .active')?.classList.remove('active');
                    
                    // Add active class to clicked filter
                    this.classList.add('active');
                    
                    // Apply filter
                    isotope.arrange({
                        filter: this.getAttribute('data-filter')
                    });
                    
                    // Trigger AOS refresh if available
                    if (typeof aosInit === 'function') {
                        aosInit();
                    }
                });
            });
        });
    }
    
    // Initialize portfolio
    initPortfolio().catch(error => {
        console.error('Error initializing portfolio:', error);
    });
}
else if (currentPath.includes('/portfolio/')) {
    import('bootstrap/js/dist/carousel').then(module => {
  });
}
})();